import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { config } from '../../../config/config';
import { setCookie } from '../../shared/hooks/use-cookie';

export function useSetCookieFromParams(paramName: string) {
    const [params] = useSearchParams();
    const currentValue = params.get(paramName);

    useEffect(() => {
        if (!currentValue) {
            return;
        }

        setCookie(paramName, currentValue, config.REGISTRATION_UTM_DATA_EXPIRY);
    }, [currentValue, paramName]);
}
